<div *ngIf="display">
    <header class="header theme-container" fxHide fxShow.gt-md>
        <div class="header-top-new">
            <div class="container-new container">
                <div class="header-left">
                    <div class="contact-info">
                        <mat-icon (click)="callPhone()" style="height: auto;" class="icon-css">call</mat-icon>
                        <span (click)="callPhone()" class="text" style="cursor: pointer;">
                            {{data.storePhoneNumber}}</span>
                        <span class="divider-new">|</span>
                        <mat-icon style="height: auto;" class="icon-css">mail</mat-icon>
                        <span class="text" (click)="composeEmail(data.email)"
                            style="cursor: pointer;">{{data.email}}</span>
                    </div>
                </div>


                <div class="header-right">
                    <div class="social-icons" *ngIf="showFooterIcon==1">
                        <span *ngFor="let item of footerIconData">

                            <button (click)="navigate(item)" mat-icon-button class="custom-icon">

                                <ng-container *ngIf="isFontAwesomeIcon(item.iconName); else materialIcon">

                                    <i [ngClass]="getFontAwesomeClass(item.iconName)" class="icon"></i>
                                </ng-container>
                                <ng-template #materialIcon>
                                    <mat-icon [svgIcon]="item.iconName" class="icon"></mat-icon>
                                </ng-template>
                            </button>
                        </span>

                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <mat-toolbar-row fxLayoutAlign="start center" style="height: auto;">

                <!-- <div fxFlex="4">
    
                </div> -->
                <div fxLayout="row" fxLayoutGap="10px" fxFlex="27">
                    <section style="padding:10px 0px;">

                        <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>

                    </section>
                </div>
                <div fxFlex="10">

                </div>

                <div fxLayout="row" fxLayoutGap="10px" fxFlex="data.disableSearchInHeader==0 ? 80 : 38" style="justify-content: end;
                align-items: end;
                margin-left: 68px;">

                    <calsoft-Menu [color]="false" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
                        [categoryArray]="item"></calsoft-Menu>

                </div>

                <div fxLayout="row" fxFlex fxLayoutGap="10px" fxLayoutAlign="end center">
                    <div *ngIf="data.disableSearchInHeader==0">
                        <div *ngIf="url != '/cart'  && url !== '/checkout' && url !=='/checkout/type'">
                            <mat-icon style=" cursor: pointer;" fxLayoutAlign="center center" *ngIf="!displaySearchBar"
                                (click)="showSearchBar()">search</mat-icon>
                        </div>


                        <div *ngIf="displaySearchBar" class="search-bar" fxHide fxShow.gt-sm fxShow.gt-sm fxLayout="row"
                            fxLayoutAlign="start center" fxFlex fxFlex.gt-sm="350px">
                            <calsoft-search (callhideSearchBar)="hideSearch($event)" showSearchBar
                                [searchbarborderRadius]="'15px'"></calsoft-search>
                        </div>
                    </div>

                </div>


                <div fxLayoutAlign="end center" fxFlex
                    *ngIf="url !== '/cart' && url !== '/checkout' && url !=='/checkout/type' ">

                    <div *ngIf="data.disableWishlistHeader==0">
                        <button (click)="wishlist()" mat-button *ngIf="url != '/account/wishlist'">
                            <mat-icon>favorite_border</mat-icon>

                        </button>
                    </div>

                    <!-- <calsoft-cart-icon [data]="data"  fxFlex></calsoft-cart-icon> -->

                </div>

                <div fxLayoutAlign="end center" fxFlex="10" *ngIf="data.disableLoginHeader==0">
                    <div>
                        <button *ngIf="!userLoggedIn" (click)="SignIn('login')" style="line-height: 15px" mat-button>
                            <div style="color: black" fxLayout="column">
                                <small>Hello, Sign in</small>
                                <span>Account & Lists</span>
                            </div>
                        </button>
                    </div>
                    <div *ngIf="data.disableLoginHeader==0">
                        <calsoft-HeaderUserProfileDropdown [data]="data" class="headerUser" *ngIf="userLoggedIn">
                        </calsoft-HeaderUserProfileDropdown>
                    </div>
                </div>
            </mat-toolbar-row>
        </div>


        <mat-toolbar fxHide fxShow.md fxShow.gt-md class="calsoft-fixed-header" 
           style="height: auto;z-index: 1000;">
            <div class="container">
                <mat-toolbar-row fxLayoutAlign="start center" style="height: auto;">

                    <!-- <div fxFlex="4">
        
                    </div> -->
                    <div fxLayout="row" fxLayoutGap="10px" fxFlex="27">
                        <section style="padding:10px 0px;">
    
                            <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
    
                        </section>
                    </div>
                    <div fxFlex="10">
    
                    </div>
    
                    <div fxLayout="row" fxLayoutGap="10px" fxFlex="data.disableSearchInHeader==0 ? 80 : 38" style="justify-content: end;
                    align-items: end;
                    margin-left: 68px;">
    
                        <calsoft-Menu [color]="false" [data]="data" [type]="'one'" style="color: #000000;" class="menu"
                            [categoryArray]="item"></calsoft-Menu>
    
                    </div>
    
                    <div fxLayout="row" fxFlex fxLayoutGap="10px" fxLayoutAlign="end center">
                        <div *ngIf="data.disableSearchInHeader==0">
                            <div *ngIf="url != '/cart'  && url !== '/checkout' && url !=='/checkout/type'">
                                <mat-icon style=" cursor: pointer;" fxLayoutAlign="center center" *ngIf="!displaySearchBar"
                                    (click)="showSearchBar()">search</mat-icon>
                            </div>
    
    
                            <div *ngIf="displaySearchBar" class="search-bar" fxHide fxShow.gt-sm fxShow.gt-sm fxLayout="row"
                                fxLayoutAlign="start center" fxFlex fxFlex.gt-sm="350px">
                                <calsoft-search (callhideSearchBar)="hideSearch($event)" showSearchBar
                                    [searchbarborderRadius]="'15px'"></calsoft-search>
                            </div>
                        </div>
    
                    </div>
    
    
                    <div fxLayoutAlign="end center" fxFlex
                        *ngIf="url !== '/cart' && url !== '/checkout' && url !=='/checkout/type' ">
    
                        <div *ngIf="data.disableWishlistHeader==0">
                            <button (click)="wishlist()" mat-button *ngIf="url != '/account/wishlist'">
                                <mat-icon>favorite_border</mat-icon>
    
                            </button>
                        </div>
    
                        <!-- <calsoft-cart-icon [data]="data"  fxFlex></calsoft-cart-icon> -->
    
                    </div>
    
                    <div fxLayoutAlign="end center" fxFlex="10" *ngIf="data.disableLoginHeader==0">
                        <div>
                            <button *ngIf="!userLoggedIn" (click)="SignIn('login')" style="line-height: 15px" mat-button>
                                <div style="color: black" fxLayout="column">
                                    <small>Hello, Sign in</small>
                                    <span>Account & Lists</span>
                                </div>
                            </button>
                        </div>
                        <div *ngIf="data.disableLoginHeader==0">
                            <calsoft-HeaderUserProfileDropdown [data]="data" class="headerUser" *ngIf="userLoggedIn">
                            </calsoft-HeaderUserProfileDropdown>
                        </div>
                    </div>
                </mat-toolbar-row>
            </div>

        </mat-toolbar>

    </header>
</div>


<div *ngIf="!display">

    <div *ngIf="mobileHeaderType==1">
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header>
    </div>

    <div *ngIf="mobileHeaderType==0">
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header-new>
    </div>

    <div *ngIf="mobileHeaderType==2">
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header3>
    </div>

    <div *ngIf="mobileHeaderType==3">
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
    </div>

    <div *ngIf="mobileHeaderType==4">
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
    </div>

    <div *ngIf="mobileHeaderType==5">
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header6>
    </div>
    <div *ngIf="mobileHeaderType==6">
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header7>
    </div>
    <div *ngIf="mobileHeaderType==7">

        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header8>
    </div>
    <div *ngIf="mobileHeaderType==8">
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
    </div>
</div>